import mix from '../../../../utils/src/lib/styles/mix'
import styles from './Tooltip.module.css'

export default function Tooltip ({ align = 'bottom', children, text }) {
    const className = mix([styles.tooltip, styles[align]])
    const hint = text
    return <div className={className} data-text={hint}>
        {children}
    </div>
}